import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, inr } from "../../lib/api";
import { Download } from "lucide-react";

export default function Downloads() {
  const [orders, setOrders] = useState([]);
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    api.get("/orders/my-orders").then(r => setOrders(r.data.filter(o => ["delivered", "completed"].includes(o.status))));
  }, []);

  return (
    <div className="space-y-4">
      <h2 className="font-display text-2xl font-bold text-[#1a3c5e]">Downloads</h2>
      {orders.length === 0 ? (
        <div className="bg-white rounded-2xl p-10 text-center text-gray-500 border border-[#1a3c5e]/10">No deliveries yet.</div>
      ) : orders.map(o => <DownloadCard key={o.id} order={o} backend={BACKEND_URL} />)}
    </div>
  );
}

function DownloadCard({ order, backend }) {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get(`/orders/${order.id}`).then(r => setItems(r.data.deliverables)); }, [order.id]);
  return (
    <div className="bg-white rounded-2xl border border-[#1a3c5e]/10 p-5">
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="font-display font-bold text-[#1a3c5e]">{order.service_name}</div>
          <div className="text-xs text-gray-500">Order #{order.id.slice(0,8)} · {inr(order.amount)}</div>
        </div>
        <Link to={`/dashboard/orders/${order.id}`} className="text-sm text-[#F7941D] hover:underline">View order →</Link>
      </div>
      <div className="space-y-2">
        {items.map(d => (
          <div key={d.id} className="flex justify-between items-center text-sm p-2.5 rounded-lg border border-[#1a3c5e]/10">
            <div>
              <div className="font-semibold text-[#1a3c5e]">{d.file_name}</div>
              <div className="text-xs text-gray-500">v{d.version} · {(d.size/1024/1024).toFixed(2)} MB</div>
            </div>
            <a href={`${backend}/api/files/${d.id}`} download>
              <button className="px-3 py-1.5 bg-[#1a3c5e] text-white rounded-lg text-xs font-semibold flex items-center gap-1.5"><Download className="w-3.5 h-3.5" />Download</button>
            </a>
          </div>
        ))}
        {items.length === 0 && <div className="text-sm text-gray-500">Files uploading soon...</div>}
      </div>
    </div>
  );
}
